import { action as apiAction } from 'api/Api'
import {
  setUser
} from '../redux/cardBlockers'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardBlockerId: number
  userId: number | null
}

const requestChangeCardBlockerUser = ({
  cardBlockerId,
  userId,
}: Payload) => async dispatch => {
  const optimisticAction = optimisticDispatch(dispatch, setUser({
    cardBlockerId,
    userId,
  }))

  try {
    await apiAction('ChangeCardBlockerUser', {
      id: cardBlockerId,
      userId,
    })
  } catch (error) {
    if (error.code !== 303) { // NoChange
      throw error
    }
  } finally {
    optimisticAction.revert()
  }
}

export default requestChangeCardBlockerUser
